import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AppUsersDto } from '../model/app-users-dto';
import { LoggedInUserService, LoggedInUserKeys } from '../service/logged-in-user.service';

export const hrGuard: CanActivateFn = (route, state) => {
  const authService: LoggedInUserService = inject(LoggedInUserService);
  const router: Router = inject(Router);
  let loggedInUser: AppUsersDto;
  loggedInUser = authService.getLoggedInUser(LoggedInUserKeys.LOGGED_IN_USER);
  if (loggedInUser && loggedInUser.authToken && (loggedInUser.userRole == 'FRACTAL_HR' || loggedInUser.userRole == 'PROJECT_MANAGER' || loggedInUser.userRole == 'VISITOR')) {
    return true;
  }
  router.navigateByUrl('/admin/sign-in');
  return false;
};
